import React, { useState } from "react";
import HamburgerMenu from "react-hamburger-menu";
import { Link } from "react-router-dom";

import "./navbar.scss";

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <div id="navbar" className={menuOpen ? "display-mobile-menu" : ""}>
        <ul>
          <li>
            <a href="https://backyourlocal.com.au/">Home</a>
          </li>
          <li>
            <Link to="/" className="active">
              Businesses
            </Link>
          </li>
          <li>
            <a href="https://backyourlocal.com.au/about-us">About Us</a>
          </li>
          <li>
            <a href="https://backyourlocal.com.au/covid-19-updates">
              COVID-19 Updates
            </a>
          </li>
          <li>
            <a href="https://backyourlocal.com.au/donate">Donate</a>
          </li>
          <li>
            <a href="https://forms.gle/amDykaS97sacG3Cm9">Register</a>
          </li>
        </ul>
      </div>

      <div id="hamburger">
        <HamburgerMenu
          isOpen={menuOpen}
          menuClicked={() => setMenuOpen(!menuOpen)}
          width={22}
          height={14}
          strokeWidth={2}
          rotate={0}
          color="black"
          borderRadius={0}
          animationDuration={0.5}
        />
      </div>
    </nav>
  );
};

export default NavBar;
